/**
 * Category labels helper — pluggable labels for ingredient categories.
 * Uses restaurant settings' `category_labels` field with sensible defaults.
 */

export const DEFAULT_CATEGORY_LABELS = {
  size:     'Taglia',
  base:     'Base',
  protein:  'Proteine',
  topping:  'Topping',
  sauce:    'Salse',
  extra:    'Extra',
  beverage: 'Bevande',
};

/**
 * Returns the label for a category key.
 * @param {string} key - Category key (e.g. 'base', 'protein')
 * @param {object|null|undefined} labels - custom labels map (from settings.category_labels)
 * @returns {string}
 */
export function categoryLabel(key, labels) {
  if (labels && typeof labels === 'object') {
    const v = labels[key];
    if (v && typeof v === 'string' && v.trim()) return v;
  }
  return DEFAULT_CATEGORY_LABELS[key] || key;
}

/** Full labels map merged with defaults. */
export function mergeCategoryLabels(labels) {
  return { ...DEFAULT_CATEGORY_LABELS, ...(labels || {}) };
}
